export const analytics = {
  _root: "/analytics",
  section: {
    _root: "/:sectionSlug",
    subsection: "/:subsectionSlug"
  },
  compareCharts: {
    _root: "/compare-charts"
  },
  configure: {
    _root: "/configure",
    metric: "/:metricID"
  }
};
